<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Promotional Prize Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput label="Title" placeholder="Enter Prize title" v-model="promotion.title" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
              label="Body"
              placeholder="Enter Body"
              v-model="promotion.body"
          />
        </CCol>
      </CRow>
<!--      <CRow v-if="promotion.image">-->
<!--        <CCol sm="12">-->
<!--          <img :src="img_url" style="width: 240px; height: 180px;" />-->
<!--          <CInputFile-->
<!--              label="Image thumbnail"-->
<!--              vertical-->
<!--              ref="file"-->
<!--              type="file"-->
<!--              id="file"-->
<!--              @change="onImageChange"-->
<!--          />-->
<!--          &lt;!&ndash;<input type="file" class="form-control" v-on:change="onImageChange">&ndash;&gt;-->
<!--          <label class="text-danger">(Image Size should be (480 X 360) and less than 1 MB)</label>-->
<!--        </CCol>-->
<!--      </CRow>-->
      <CCardBody>
        <CRow v-if="promotion.image">
          <CCol sm="12" >
            <img :src="img_url" style="width: 300px" />
            <CButton color="danger" @click="removeImage">Remove Banner</CButton>
          </CCol>
        </CRow>
        <CRow v-else>
          <CCol>
            <span>No Popup is set currently</span>
          </CCol>

        </CRow>

        <CInputFile
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
        >(Image Size should be (541 X 627) and less than 1 MB)</label
        ><br />
        </CRow>
      </CCardBody>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Promotion
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "BkashPromotionEdit",
  data() {
    return {
      promotion: {},
      img_url: "",
      categories: [],
      selectedCategory: 1,
    };
  },
  created() {
    this.getPrizeDetails();
  },
  methods: {
    getPrizeDetails() {
      let formData = new FormData();
      formData.append("id", this.$route.params.id);

      this.$axios
          .post(`${ADMIN_URL}/prizes-details`, formData)
          .then((response) => {
            console.log(response.data);
            this.promotion = response.data.data;
            this.img_url = ROOT_URL + "/" + this.promotion.image;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.promotion.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.promotion.title);
      formData.append("body", this.promotion.body);
      formData.append("image", this.promotion.image);
      formData.append("_method", "post");
      formData.append("id", this.$route.params.id);

      this.$axios
          .post(`${ADMIN_URL}/prizes-update`, formData, config)
          .then((response) => {
            console.log("Success", response);
            currentObj.success = response.data.success;
            console.log(response.data);
            if(response.data.success)
            {
              this.$swal("Success", response.data.message, "success");
            }
            else
            {
              this.$swal("Error",  response.data.message, "error");
            }

          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    },
  },
};
</script>

<style scoped>
</style>
